import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CompleteAppointmentFitterSheetComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-complete-appointment-fitter-dialog',
  styleUrls: ['./complete-appointment-fitter-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CompleteAppointmentFitterSheetComponent],
  template: `
    <sc-complete-appointment-fitter-sheet
      (buttonClickEvent)="onButtonClick($event)"
    ></sc-complete-appointment-fitter-sheet>
  `,
})
export class CompleteAppointmentFitterDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      CompleteAppointmentFitterDialogComponent,
      string
    >
  ) {}

  onButtonClick($event) {
    this.dialogRef.close($event);
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    this.onButtonClick('cancel');
  }
}
